import { Auth, API } from 'aws-amplify';

export const requireAdmin = async () => {
  try {
    const userInfo = await Auth.currentUserInfo();
    if (!userInfo) return false;

    const response = await API.graphql({
      query: `
        query {
          listAdmin6tmev5bluvberlff7ql57zqxu4Pittaputs(limit: 100) {
            items {
              id
            }
          }
        }
      `,
      authMode: 'AMAZON_COGNITO_USER_POOLS',
    });

    const adminList = response.data.listAdmin6tmev5bluvberlff7ql57zqxu4Pittaputs.items;
    const isAdmin = adminList.some(value => value.id === userInfo.attributes.sub);
    return isAdmin;

  } catch (error) {
    console.error('管理者権限チェックエラー:', error);
    return false;
  }
};
